import React from 'react';
import { useTranslation } from 'react-i18next';
import Modal from 'components/reusable/Modal';
import { Row, Col } from 'antd';
import { ReactComponent as DisabledProfReportIcon } from 'assets/img/icons/disabledProfReportIcon.svg';

const DisabledProfModal = ({ modalOpen, setModalOpen, type }) => {
  const { t } = useTranslation();
  return (
    <Modal isOpen={modalOpen} setIsOpen={setModalOpen} size="md" className="disabledProfModal">
      <Row className="space-vertical-md">
        <Col xs={5} sm={4} span={3} className="justify-content-center align-items-center">
          <DisabledProfReportIcon />
        </Col>
        <Col xs={19} sm={20} span={21}>
          <Row>
            <Col span={24}>
              <span className="title">{t(`publicProf.trusted.title.${type}`)}</span>
            </Col>
            <Col span={24}>
              <span className="message">{t(`publicProf.trusted.message.${type}`)}</span>
            </Col>
          </Row>
        </Col>
      </Row>
    </Modal>
  );
};

export default DisabledProfModal;
